export default __webpack_public_path__ + "static/media/shrutiAsharp.a73cfc09.wav";